import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { assignValueById } from 'utils/Activities/activitiesRemoveDuplicates';
import { useSchool } from '../../SchoolContext';
import { getActivityData } from '../../utils';
import ProfileSection from '../ProfileSection';

export default function EventsActivities({ isFetching }) {
  const { schoolData } = useSchool();
  const activities = getActivityData(schoolData || []) || [];
  const [eventsActivities, setEventsActivities] = useState({});

  useEffect(() => {
    const loadActivities = async () => {
      if (!activities.length) return;
      const events = await assignValueById(activities, 18);
      setEventsActivities(events);
    };

    loadActivities();
  }, [activities]);

  if (isFetching) {
    return <>...loading</>;
  }

  return (
    <>
      {eventsActivities.length > 0 ? (
        <ProfileSection
          title="Eventos Institucionales"
          subtitleLyrics={{
            subtitle: '',
            lyrics: eventsActivities[0]?.description,
          }}
        />
      ) : null}
    </>
  );
}

EventsActivities.propTypes = {
  isFetching: PropTypes.bool.isRequired,
};
